import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import { createCoeffAbattEv, findCoeffAbattEv, listCoeffAbattEv, updateCoeffAbattEv } from "./coeffAbattService";

const coeffAbattEvSlice = createModule({
    name: "coeffAbattEv",
    initialState: {
        coeffs: [],
        isFetching: false,
        error: null
    },
    reducers: {
        listCoeffAbattEv: (state) => {
            state.isFetching = true;
        },
        findCoeffAbattEv: (state) => {
            state.isFetching = true;
        },
        createCoeffAbattEv: (state) => {
            state.isFetching = true;
        },
        updateCoeffAbattEv: (state) => {
            state.isFetching = true;
        },
        fetchedData: (state, payload) => {
            state.coeffs = payload.body;
        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state) => {
            state.isFetching = false;
            state.error = "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.findCoeffAbattEv]({payload}) {
            try {
                const {data} = yield findCoeffAbattEv(payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.createCoeffAbattEv]({payload}) {
            try {
                console.log(payload.data);
                yield createCoeffAbattEv(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.listCoeffAbattEv]() {
            try {
                const { data } = yield listCoeffAbattEv();
                console.log(data)
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.updateCoeffAbattEv]({payload}) {
            try {
                yield updateCoeffAbattEv(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        }
    })
});

export default coeffAbattEvSlice;
export const coeffAbattEvActions = coeffAbattEvSlice.actions;
